import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Slick from 'react-slick';
import 'slick-carousel/slick/slick.css';

export default class Carousel extends Component {
  slickRef = null;

  render() {
    const { autoplay, children, draggable } = this.props;

    const settings = {
      autoplay,
      draggable,
      slidesToShow: 3,
      cssEase: 'ease-in-out',
      swipeToSlide: true,
      centerMode: false,
      arrows: false,
      infinite: true,
      responsive: [
        { breakpoint: 1440, settings: { slidesToShow: 3 } },
        { breakpoint: 900, settings: { slidesToShow: 2 } },
        { breakpoint: 600, settings: { slidesToShow: 1 } },
      ],
    };

    return (
      <Slick
        {...settings}
        ref={ref => {
          this.slickRef = ref;
        }}
      >
        {children}
      </Slick>
    );
  }
}

Carousel.propTypes = {
  autoplay: PropTypes.bool,
  children: PropTypes.node.isRequired,
  draggable: PropTypes.bool,
};

Carousel.defaultProps = {
  autoplay: false,
  draggable: true,
};



// WEBPACK FOOTER //
// ./src/components/wrappers/Carousel/index.js